// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "employees-21b62107/chunk-" + {"190": "596e374435477204","288": "b64d77d9fd2076a8","52": "a85187306c0cf7ed",}[chunkId] + ".js"
}